import { Injectable } from '@angular/core';
import { Resolve, Router } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { filter, first, map } from 'rxjs/operators';
import { ApplicationActiveState, ApplicationTile } from '../models/index';
import { GaApplicationsService } from '../services/applications.service';
import { UserSession } from './../../session/models/SessionUser';
import { GaSessionService } from './../../session/services/session.service';

export interface IResolvedData {
    applications: ApplicationTile[];
    activeApplication: ApplicationTile;
    appState: ApplicationActiveState;
    sessionUser: UserSession;
}

@Injectable()
export class AccessResolver implements Resolve<boolean> {
    constructor(
        private router: Router,
        private applicationsService: GaApplicationsService,
        private sessionService: GaSessionService,
    ) { }

    resolve(): Observable<boolean> {
        return this.waitApplicationToLoad();
    }

    waitApplicationToLoad(): Observable<boolean> {
        const combine$ = combineLatest([
            this.applicationsService.applications$,
            this.applicationsService.activeApplication$,
            this.applicationsService.activeApplicationState$,
            this.sessionService.sessionUser$
        ])
            .pipe(
                map(([applications, activeApplication, appState, sessionUser]) =>
                    ({ applications, activeApplication, appState, sessionUser })),
                filter((value, index) => {
                    // NotFound
                    if (value.appState === ApplicationActiveState.NotFound || value.appState === ApplicationActiveState.Error) {
                        this.router.navigateByUrl('/404');

                        return false;
                    }
                    return (value?.sessionUser?.id ?? false) && value.applications.length > 0 && !!value.activeApplication;
                }),
                map(value => {
                    return !!value;
                }),
                first()
            );

        return combine$;
    }

}
